export const discoveredServiceVia = [
  { key: 'Instagram', option: 'Instagram', value: 'Instagram' },
  { key: 'Facebook', option: 'Facebook', value: 'Facebook' },
  { key: 'Google', option: 'Google', value: 'Google' },
  { key: 'Word of mouth', option: 'Boca a Boca', value: 'Word-of-mouth' },
  { key: 'Mailbox', option: 'Mensajes', value: 'Mailbox' },
  { key: 'Press', option: 'Prensa', value: 'Press' },
  { key: 'Radio', option: 'Radio', value: 'Radio' },
  { key: 'Other', option: 'Otro', value: 'Other' },
];

export const whatYouWantToDo = [
  { key: 'Book-a-pool', option: 'Reservar una piscina', value: 'bookPool_c' },
  { key: 'Share-my-pool', option: 'compartir mi piscina', value: 'sharePool_p' },
];

export const typeOfSpace = [
  { key: 'Pool with Jacuzzi/Spa', option: 'Pool with Jacuzzi/Spa', value: 'Pool with Jacuzzi/Spa' },
  {
    key: 'Pool with Jacuzzi/Spa+Sauna',
    option: 'Pool with Jacuzzi/Spa+Sauna',
    value: 'Pool with Jacuzzi/Spa+Sauna',
  },
  { key: 'Pool of Garden', option: 'Pool of Garden', value: 'Pool of Garden' },
  {
    key: 'Swimming pool with terrace',
    option: 'Swimming pool with terrace',
    value: 'Swimming pool with terrace',
  },
  {
    key: 'Swimming pool in attic',
    option: 'Swimming pool in attic',
    value: 'Swimming pool in attic',
  },
  {
    key: 'Communal Swimming Pool',
    option: 'Communal Swimming Pool',
    value: 'Communal Swimming Pool',
  },
];

export const ownerPresent = [
  { key: 'YEAH', option: 'YEAH', value: 'YEAH' },
  { key: 'NO', option: 'NO', value: 'NO' },
  { key: 'Sometimes', option: 'Sometimes', value: 'Sometimes' },
];

export const bathrooms = [
  { key: 'Outside the house', option: 'Outside the house', value: 'Outside the house' },
  { key: 'Inside the house', option: 'Inside the house', value: 'Inside the house' },
  { key: 'Laptop', option: 'Laptop', value: 'Laptop' },
];

export const poolMaintenance = [
  { key: 'Chlorine', option: 'Chlorine', value: 'Chlorine' },
  { key: 'Salt', option: 'Salt', value: 'Salt' },
];
export const privacy = [
  {
    key: 'Little - neighbors can see the pool',
    option: 'Little - neighbors can see the pool',
    value: 'Little - neighbors can see the pool',
  },
  {
    key: 'Quite a bit - it is difficult for neighbors to see the pool',
    option: 'Quite a bit - it is difficult for neighbors to see the pool',
    value: 'Quite a bit - it is difficult for neighbors to see the pool',
  },
  {
    key: "A lot - the neighbors don't see the pool",
    option: "A lot - the neighbors don't see the pool",
    value: "A lot - the neighbors don't see the pool",
  },
];
export const allowBringingFood = [
  { key: 'YEAH', option: 'YEAH', value: 'YEAH' },
  { key: 'NO', option: 'NO', value: 'NO' },
];
export const allowBringingDrinks = [
  { key: 'YEAH', option: 'YEAH', value: 'YEAH' },
  { key: 'NO', option: 'NO', value: 'NO' },
];
export const allowBringingAlcohol = [
  { key: 'YEAH', option: 'YEAH', value: 'YEAH' },
  { key: 'NO', option: 'NO', value: 'NO' },
];
export const allowMusic = [
  { key: 'YEAH', option: 'YEAH', value: 'YEAH' },
  { key: 'NO', option: 'NO', value: 'NO' },
];
export const priceByGuestCount = [
  { key: '1-5', label: '1-5', value: '1-5' },
  { key: '6-10', label: '6-10', value: '6-10' },
  { key: '11-15', label: '11-15', value: '11-15' },
  { key: '16-20', label: '16-20', value: '16-20' },
  { key: '21-25', label: '21-25', value: '21-25' },
  { key: '26-30', label: '26-30', value: '26-30' },
  { key: '31-50', label: '31-50', value: '31-50' },
  { key: '51+', label: '+51', value: '51_above' },
];
